import { isValidPrice } from './isValidPrice';
import { getNumberString } from './getNumberString';
import { isValidMaxNumber } from '../../../utils/validators';
import { EPriceErrorMessages } from '../constants';
import { NBSP } from '../../../constants/symbols';

type TValidatorCbExtension = (value: string, required: boolean) => string | void;

const formatPrice = (num: string): string => {
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
};

export const checkIsDigitCount =
  (count: number) =>
  (value: string): string | void => {
    if (isValidPrice(value) && getNumberString(value).length < count) {
      return `Минимум — ${formatPrice(`1${'0'.repeat(count - 1)}`)} ₽`;
    }
  };

const validatePriceIsInteger = (value: string): boolean => {
  return !/\./.test(value);
};

export const validateGte = (
  gte: string,
  lte: string,
  required: boolean,
  validatorCb?: TValidatorCbExtension,
): string | null => {
  const error = validatorCb?.(gte, required);

  if (error) {
    return error;
  }

  if (isValidPrice(gte) && !isValidMaxNumber(Number(getNumberString(gte)))) {
    return EPriceErrorMessages.Max;
  }

  if (isValidPrice(gte) && !validatePriceIsInteger(gte)) {
    return EPriceErrorMessages.OnlyInteger;
  }

  return (!gte && !required) || isValidPrice(gte) || isValidPrice(lte) ? null : EPriceErrorMessages.GteRequired;
};

export const validateLte = (
  gte: string,
  lte: string,
  required: boolean,
  validatorCb?: TValidatorCbExtension,
): string | null => {
  const error = validatorCb?.(lte, required);

  if (error) {
    return error;
  }

  if (isValidPrice(gte) && isValidPrice(lte) && Number(getNumberString(lte)) < Number(getNumberString(gte))) {
    return EPriceErrorMessages.GteLte;
  }

  if (isValidPrice(lte) && !isValidMaxNumber(Number(getNumberString(lte)))) {
    return EPriceErrorMessages.Max;
  }

  if (isValidPrice(lte) && !validatePriceIsInteger(lte)) {
    return EPriceErrorMessages.OnlyInteger;
  }

  return (!lte && !required) || isValidPrice(lte) || isValidPrice(gte) ? null : EPriceErrorMessages.LteRequired;
};

export const validatePrice = (value: string, required: boolean, validatorCb?: TValidatorCbExtension) => {
  const error = validatorCb?.(value, required);

  if (error) {
    return error;
  }

  if (isValidPrice(value) && !isValidMaxNumber(Number(getNumberString(value)))) {
    return EPriceErrorMessages.Max;
  }

  if (isValidPrice(value) && !validatePriceIsInteger(value)) {
    return EPriceErrorMessages.OnlyInteger;
  }

  return (!value && !required) || isValidPrice(value) ? null : EPriceErrorMessages.Required;
};
